// Code used from https://github.com/TheBeyondGroup/shopify-rich-text-renderer/blob/main/src/index.js
// As the anchor link starts with "undefined" which is default from shopify, and it goes to new tab(client doesn't want the link to go to a new tab),
// so I've refactored the buildLink to start with "_self" and followed by target value from shopify(if any).

export function convertSchemaToHtml(schema: any, scoped = false) {
  if (typeof schema === 'string' || schema instanceof String) {
    // @ts-ignore
    schema = JSON.parse(schema);
  }

  let html = ``;
  if (schema.type === 'root' && schema.children.length > 0) {
    if (scoped) {
      html += `
      <div class="${scoped ? `rte-content` : scoped}">
        ${convertSchemaToHtml(schema.children)}
      </div>
      `;
    } else {
      html += convertSchemaToHtml(schema.children);
    }
  } else {
    for (const el of schema) {
      switch (el.type) {
        case 'paragraph':
          html += buildParagraph(el);
          break;
        case 'heading':
          html += buildHeading(el);
          break;
        case 'list':
          html += buildList(el);
          break;
        case 'list-item':
          html += buildListItem(el);
          break;
        case 'link':
          html += buildLink(el);
          break;
        case 'text':
          html += buildText(el);
          break;
        default:
          break;
      }
    }
  }
  return html;
}

export function buildParagraph(el: { children: any }) {
  if (el?.children) {
    return `<p>${convertSchemaToHtml(el?.children)}</p>`
  }
}

export function buildHeading(el: { children: any; level: any }) {
  if (el?.children) {
    return `<h${el?.level}>${convertSchemaToHtml(el?.children)}</h${el?.level}>`
  }
}

export function buildList(el: { children: any; listType: string }) {
  if (el?.children) {
    if (el?.listType === 'ordered') {
      return `<ol>${convertSchemaToHtml(el?.children)}</ol>`
    } else {
      return `<ul>${convertSchemaToHtml(el?.children)}</ul>`
    }
  }
}

export function buildListItem(el: { children: any }) {
  if (el?.children) {
    return `<li>${convertSchemaToHtml(el?.children)}</li>`
  }
}

export function buildLink(el: { url: any; title: any; target: any; children: any }) {
  return `<a href="${el?.url}" title="${el?.title}" target="${
    el?.target ? el?.target : '_self'
  }">${convertSchemaToHtml(el?.children)}</a>`
}

export function buildText(el: { bold: any; value: any; italic: any }) {
  if (el?.bold) {
    return `<strong>${el?.value}</strong>`
  }
  if (el?.italic) {
    return `<em>${el?.value}</em>`
  }
  return el?.value
}
